<template>
  <autocomplete-multiple name="Филиалы" :items="items" :select.sync="localSelect" @load="load" :loading="loadState.isLoading">
    <template v-slot:itemIcon="{item}">
      <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-3px"/>
    </template>
    <template v-slot:selectedInfo="{item}">
      <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-2px"/> {{item.name}}
    </template>
  </autocomplete-multiple>
</template>

<script>
import State from "@/plugins/state";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import {
  Entity_ComBranch,
} from "../../../EntityStoreCacheService";

export default {
  components: {AutocompleteMultiple},
  props:[
    'select','globalState','preLoad'
  ],
  data:()=>({
    loadState: new State(),
    items: [],
    localSelect: null
  }),
  watch: {
    select() {
      this.localSelect = this.select;
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
      if(typeof this.globalState!=='undefined'){
        let arr = this.localSelect;
        arr.forEach((v)=>{
          v.id = parseInt(v.id);
        });
        localStorage['globalState_comBranchs'] = JSON.stringify(arr);
      }
    }
  },
  mounted() {
    if (typeof this.preLoad !== 'undefined')
      this.load();

    this.localSelect = this.select;
    if(typeof this.globalState!=='undefined' && typeof localStorage['globalState_comBranchs']!=='undefined') {
      let arr = JSON.parse(localStorage['globalState_comBranchs']);
      if(arr.length>0){
        arr.forEach((v)=>{
          v.id = parseInt(v.id);
        });
        this.localSelect = arr;
        this.load();
      }
    }

  },
  methods:{
    load(){
      new Entity_ComBranch()
      .selects(Entity_ComBranch.id)
      .selects(Entity_ComBranch.name)
      .selects(Entity_ComBranch.color)
      .order(Entity_ComBranch.name, true)
      .page(1).onPage(1000)
      .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
      .request((v)=>{
          this.items = v.items;
      }, (e)=>{
        console.error(e.response.data.message);
      })  
  }
  }
}
</script>